import { render, staticRenderFns } from "./listPost2.vue?vue&type=template&id=79564a00&scoped=true&"
import script from "./listPost2.vue?vue&type=script&lang=js&"
export * from "./listPost2.vue?vue&type=script&lang=js&"
import style0 from "./listPost2.vue?vue&type=style&index=0&id=79564a00&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79564a00",
  null
  
)

export default component.exports